module.exports = __webpack_public_path__ + "static/quality-2b7be936111ff2d5b76d218651edd78f.png";